<template>
  <div class="order-price">
    <div class="order-price_title">Итого</div>
    <div class="order-price_items">
      <div class="order-price_item">
        <div class="order-price_item-name">Заказ</div>
        <div class="order-price_item-value">{{ getPriceOrderLocale }}</div>
      </div>
      <div class="order-price_item">
        <div class="order-price_item-name">Доставка</div>
        <div class="order-price_item-value">{{ getPriceDeliveryLocale }}</div>
      </div>
      <div class="order-price_item">
        <div class="order-price_item-name">К оплате</div>
        <div class="order-price_item-value sum">{{ getPriceSumLocale }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import localPrice from '../../utils/localPrice'

  export default {
    name: 'Price',
    computed: {
      ...mapGetters('order', [
        'getPriceDelivery',
        'getPriceOrder',
        'getPriceSum'
      ]),
      getPriceDeliveryLocale: function () {
        return localPrice(this.getPriceDelivery)
      },
      getPriceOrderLocale: function () {
        return localPrice(this.getPriceOrder)
      },
      getPriceSumLocale: function () {
        return localPrice(this.getPriceSum)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Price.vue